import { Flex, Avatar } from "@chakra-ui/react";
import { RelatorioUnidadePessoa } from "core/features/relatorios/typings/index";
import { formatCNPJ } from "@brazilian-utils/brazilian-utils";
import { formatPhone } from "infra/helpers/number";
import { TipoContatoEnum } from "core/features/auth/typings/user";

interface TableItemRowProps {
  pessoa?: RelatorioUnidadePessoa;
}
function TableItemRow({ pessoa }: TableItemRowProps) {
  return (
    <>
      <Flex justifyContent="center" flex={1}>
        <Flex w="100px" justifyContent="center">
          <Avatar name={pessoa?.nome} src={pessoa?.imagemUrl || ""} />
        </Flex>
        <Flex flexDirection="column" flex={1}>
          <Flex>{pessoa?.nome}</Flex>
          <Flex>{formatCNPJ(pessoa?.documento!)}</Flex>
        </Flex>
      </Flex>

      <Flex flexDirection="column" flex={1}>
        {pessoa?.contatos.map((contato) => (
          <Flex>
            {contato.tipoContatoId === TipoContatoEnum.Celular ||
            contato.tipoContatoId === TipoContatoEnum.Telefone
              ? formatPhone(contato.conteudo)
              : contato.conteudo}
          </Flex>
        ))}
      </Flex>
      <Flex flex={1}>{pessoa?.tipoUnidadePessoaNome}</Flex>
      <Flex flex={1}> {pessoa?.endereco}</Flex>
    </>
  );
}

export default TableItemRow;
